<template>
  <div class="page">
    <div class="m-page">
      <div class="x-flex-between">
        <div>
          <span class="x-font-color x-font-15 m-user">{{keys==2 ? '重置密码' : '验证手机'}}</span>
        </div>
        <span class="x-font-12">{{keys}}/2</span>
      </div>
      <transition name="van-fade">
        <mKey1 v-show="keys==1" ref="mKeys1" @isOK="isOK"/>
      </transition>
      <transition name="van-fade">
        <mKey2 v-show="keys==2" ref="mKeys2" @isOK="isOK" @submit="submit"/>
      </transition>
    </div> 
  </div>
</template>

<script>
  import mKey1 from "./components/m-key1"
  import mKey2 from "./components/m-key2"
  export default {
    components: {mKey1,mKey2 },
    data () {
      return {
        keys: 1
      }
    },
    created () {

    },
    methods: {
      isOK(i){
        this.keys = i
      },
      //重置密码
      submit(){
        let form1 = this.$refs.mKeys1.form
        let form2 = this.$refs.mKeys2.form
        let params = Object.assign({}, form1, form2)
        this.http.postRequest({
          url:'app/userInfo/setPassword',
          msg:params,
          success:(res)=>{
            this.$router.replace({
              path:'/passSuccess'
            })
          }
        },true)
      }
    },
    mounted () {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  @import "~@/assets/css/variable.less";
  .page{
    background: #F4F6F9;
    .m-page {
      position: absolute;
      top: 12px;
      left: 12px;
      right: 12px;
      bottom: 12px;
      margin: auto;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      z-index: 2;
      background: #ffffff;
      border-radius: 4px;
      padding: 15px;
      .m-user{
        border-left: 3Px solid #457DF9;
        padding-left: 4px;
      }
    }
  }
</style>

